<template>
  <el-dialog width="85%" :visible.sync="showSpecialtiesModal" :before-close="applySpecialtyModal"
    :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false"
    title="Select Specialties and Set Coding Details" @open="saveDisabled = true">
    <el-form>
      <el-row :gutter="10">
        <el-col :span="15">
          <el-row id="specialties">
            <el-col :span="8" v-for="i in [1,2,3]" :key="i">
              <span v-for="s in specialties.slice((i - 1) * 11, i * 11)" :key="s.key">
                <h4 v-if="s.key === 'Other'" class="heading"
                  style="margin-right: 30px; margin-bottom: 5px; padding-bottom: 4px;">Not Listed</h4>
                <el-form-item>
                  <input type="checkbox" @change="toggleSpecialty(s)" v-model="s.selected">{{s.key}}
                </el-form-item>
              </span>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="9" style="min-height: 300px; border-left: 1px solid #ccc; ">
          <el-row>
            <el-alert style=" width: 100%; margin-bottom: 5px;" type="warning"
              v-if="!specialties.some(x => x.selected === true)" :closable="false">Please select at least 1 Specialty
            </el-alert>
            <el-alert style=" width: 100%; margin-bottom: 5px;" type="warning"
              v-if="specialtiesModalMessage && specialties.some(x => x.selected === true && !x.isDx && !x.isEM && !x.isSurgCpt)"
              :closable="false">
              {{specialtiesModalMessage}}</el-alert>
            <el-collapse id="proCollapse" v-model="activeNames" v-if="specialties.some(x => x.selected === true)">
              <el-collapse-item v-for="s in specialties.filter(x => x.selected === true)" :key="s.specialtyId"
                :name="s.specialtyId">
                <template slot="title">
                  {{s.key}}
                </template>
                <el-row :gutter="10">
                  <el-col :span="15" style="margin-top: 10px;">
                    <strong>Codes to be Assigned</strong>
                    <div style="margin-top: 10px;">
                      <input type="checkbox" @change="onSpecialtyDetailChange" v-model="s.isDx">ICD 10 Diagnosis
                    </div>
                    <div>
                      <input type="checkbox" @change="onSpecialtyDetailChange" v-model="s.isEM">E&M Codes
                    </div>
                    <div>
                      <input type="checkbox" @change="onSpecialtyDetailChange" v-model="s.isSurgCpt">Surgical CPT Codes
                    </div>
                    <div style="margin: 5px 0px 0px 0px;" v-if="s.key === 'Other' && s.selected">
                      Other Description
                      <el-input type="text" @input="onSpecialtyDetailChange" v-model="s.description">
                      </el-input>
                    </div>
                  </el-col>
                  <el-col :span="9" style="margin-top: 10px;">
                    <strong>Place of Service</strong>
                    <div style="margin-top: 10px;">
                      <input type="checkbox" @change="onSpecialtyDetailChange" v-model="s.isHospital">Hospital
                    </div>
                    <div>
                      <input type="checkbox" @change="onSpecialtyDetailChange" v-model="s.isClinic">Clinic
                    </div>
                  </el-col>
                </el-row>
              </el-collapse-item>
            </el-collapse>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button plain @click="cancelModal">Cancel</el-button>
      <el-button :disabled="applyDisabled" type="primary" @click="applySpecialtyModal">Apply</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      showSpecialtiesModal: {
        type: Boolean,
        required: true
      },
      specialties: {
        type: Array,
        required: true
      },
      getCodingDetailsText: {
        type: Function
      }
    },
    data: function () {
      return {
        specialtiesModalMessage: '',
        saveDisabled: true,
        activeNames: []
      }
    },
    computed: {
      hasSelectedSpecialties() {
        return this.specialties.some(x => x.selected === true)
      },
      applyDisabled() {
        return this.saveDisabled || !this.hasSelectedSpecialties
      }
    },
    methods: {
      cancelModal() {
        this.specialtiesModalMessage = ''
        this.$emit('cancel')
      },
      onSpecialtyDetailChange() {
        if (this.hasSelectedSpecialties) {
          this.saveDisabled = false
        }
      },
      toggleSpecialty(row) {
        if (row.selected) {
          this.activeNames.push(row.specialtyId)
        } else {
          const activeIndex = this.activeNames.findIndex(x => x === row.specialtyId)
          if (activeIndex > -1) {
            this.activeNames.splice(activeIndex, 1)
          }
          row.isDx = false
          row.isEM = false
          row.isSurgCpt = false
          row.isClinic = false
          row.isHospital = false
        }
        if (this.hasSelectedSpecialties) {
          this.saveDisabled = false
        } else {
          this.saveDisabled = true
          this.specialtiesModalMessage = ''
        }
      },
      applySpecialtyModal() {
        if (!this.specialties.some(x => x.selected)) {
          this.specialtiesModalMessage = 'Please select at least 1 Specialty'
          return
        }

        if (this.specialties.some(x => x.selected && !x.isHospital && !x.isClinic && !x.isDx && !x.isEM && !x.isSurgCpt)) {
          this.specialtiesModalMessage = 'Please set Codes to be Assigned for all selected Specialties'
          return
        }

        this.specialtiesModalMessage = ''
        this.activeNames = []
        this.$emit('apply')
      }
    }
  }
</script>

<style scoped>
  #specialties>>>.el-form-item {
    margin-bottom: 0px;
  }

  .specialties-popover>>>.el-form-item {
    margin-bottom: 5px !important;
  }

  #specialties p {
    line-height: 1;
    margin: 0px 0px 0px 22px;
    max-width: 210px;
    overflow: hidden;
    padding: 2px 1px 2px 1px;
    border-radius: 3px;
    background: rgba(87, 204, 244, .5);
  }

  /* collapse */
  >>>#proCollapse {
    border-top: 1px solid #b4bccc;
    border-bottom: 1px solid #b4bccc;
  }

  >>>#proCollapse .el-collapse-item__header {
    height: 30px !important;
    line-height: 30px !important;
    padding-left: 10px;
    border-bottom: 1px solid #b4bccc;
    color: #606266;
    font-weight: 500;
    background: #ffffff !important;
  }

  >>>#proCollapse .el-collapse-item__header:hover {
    background-color: rgb(238, 238, 238) !important;
  }

  >>>#proCollapse .el-collapse-item.is-active .el-collapse-item__header {
    background-color: rgb(238, 238, 238) !important;
  }

  >>>#proCollapse .el-collapse-item.is-active div[aria-controls*="el-collapse-content-"] {
    background-color: rgb(238, 238, 238) !important;
  }

  >>>#proCollapse .el-form-item {
    padding: 0px 0px 15px 0px;
  }
</style>
